// extracted by mini-css-extract-plugin
export default {"container":"MobileStickyHeader_container__FJ6tt","title":"MobileStickyHeader_title__8DalA"};